<template>
  <div>
    <ModalConfirm :showMe="showMe" @confirmed="modalResponse" />
    <ShareComponent
      :shareProject="shareProject"
      :board="board"
      @hideShare="shareProject = !shareProject"
    />
    <p
      class="board-card"
      :data-board-id="board.board_id"
      :class="{'items-due': hasItemsDue, 'title_only': !userOwns, 'is-archived': archived,'marked-done':isDone}"
    >
      <span v-if="onArchivedPage && userOwns" class="unarchive-project">
        <i class="fa fa-reply" @click="unArchive"></i>
      </span>

      <span
        v-if="!onBoardPage && !onArchivedPage"
        class="board-open"
        :class="{'title_only': !userOwns}"
        @click="goToBoard(board.board_id)"
      >
        <i class="fas fa-arrow-circle-right"></i>
      </span>
      <span v-if="onBoardPage && userOwns" class="board-open" @click="shareProject = !shareProject">
        <i class="fas fa-share-alt"></i>
      </span>
      <span v-if="onBoardPage && userOwns" class="archive-project">
        <i class="fas fa-archive" @click="archiveProject"></i>
      </span>
      <span
        class="board-name"
        @click="editIfOwn"
        v-if="!editingName"
        :class="{'marked-done':isDone }"
      >{{ editedName }}</span>
      <span class="board-name-editing" v-if="editingName">
        <input type="text" v-model="localName" @keydown="finishEditing" />
      </span>

      <span class="board-delete" v-if="userOwns">
        <i class="fas fa-trash" @click="deleteMe"></i>
      </span>
    </p>
    <div class="shared-with" v-if="onBoardPage  && userOwns">
      <span
        :id="person.userId"
        @click="removeUser"
        class="share-person"
        v-for="person in board.sharedUsers"
        :key="person.userId"
      >{{ person.name }}</span>
    </div>
  </div>
</template>

<script>
import db from "@/fb/init";
import firebase from "firebase/app";

import { EventBus } from "@/eventbus";

import ModalConfirm from "@/components/ModalConfirm";

import ShareComponent from "@/components/ShareComponent";

export default {
  name: "BoardItem",
  components: { ModalConfirm, ShareComponent },
  props: ["board"],
  data() {
    return {
      localName: null,
      editingName: false,
      showMe: false,
      shareProject: false,
      people: [],
      currentUserId: null
    };
  },
  mounted() {
    this.currentUserId = window.sessionStorage.getItem("userId");
    // window.sessionStorage.setItem("boardId", this.board.board_id);
  },
  computed: {
    onBoardPage() {
      return this.$route.params.id ? true : false;
    },

    isDone() {
      return this.board.done;
    },

    archived() {
      return this.board.archived;
    },

    onArchivedPage() {
      return this.$route.name === "archived";
    },

    editedName() {
      return this.localName || this.board.name;
    },

    hasItemsDue() {
      return this.board.itemsDue && this.board.itemsDue.length > 0;
    },

    userOwns() {
      return this.board.userId === this.currentUserId;
    }
  },
  watch: {
    editingName() {
      this.localName = this.localName || this.editedName;
    }
  },
  methods: {
    editIfOwn() {
      if (this.userOwns) {
        this.editingName = !this.editingName;
      }
    },

    deleteMe() {
      EventBus.$emit("clearFlash");
      this.showMe = true;
    },

    goToBoard(id) {
      this.$router.push("/boards/" + id);
    },

    finishEditing(e) {
      EventBus.$emit("clearFlash");
      if (e.which === 27) {
        this.editingName = false;
      }
      if (e.which === 13) {
        db.collection("boards")
          .doc(this.board.board_id)
          .update({
            name: this.localName
          })
          .then(() => (this.editingName = false))
          .catch(err => {
            const messageObj = {
              message: err.message,
              status: "error",
              duration: 3000
            };
            EventBus.$emit("showFlash", messageObj);
          });
      }
    },

    archiveProject() {
      db.collection("boards")
        .doc(this.board.board_id)
        .update({ archived: true });
    },

    unArchive() {
      db.collection("boards")
        .doc(this.board.board_id)
        .update({ archived: false });
    },

    hideShare() {
      this.shareProject = false;
    },

    removeUser(e) {
      const id = e.target.id;
      const user = this.board.sharedUsers.find(el => el.userId === id);
      db.collection("boards")
        .doc(this.board.board_id)
        .update({
          sharedUsers: firebase.firestore.FieldValue.arrayRemove(user)
        });
    },

    modalResponse(response) {
      if (response) {
        EventBus.$emit("deleteBoard", this.board);
      }
      this.showMe = false;
    }
  }
};
</script>
